import { useRoutes} from "react-router-dom";
import ChatTest from "./components/live-api/chat-test";
import App from "./App";

const AppRouting = () => {
    console.log("URL actual completa from app routing:", window.location);
    return useRoutes([
        {
            path: '/',
            element: <App/>
            // element: <ChatTest/>
        },
        {
            path: '/:id/:userId',
            element: <ChatTest/>
        },
        {
            path: '/:id/:userId/:messageId',
            element: <ChatTest/>
        },
        {
            path: '/:id',
            element: <ChatTest/>
        },
    ]);
}

export default AppRouting;